import type { TNavEntryView } from '../components/types'

const isSamePath = (href: string, pathname: string): boolean =>
    href === pathname || href === `${pathname}/`

/**
 * audio-web underlines the nav entry the visitor is on. It resolves each landing page through its own
 * `is<Tool>Page` helper; here the entry's own href is the whole rule, which gives the same answer for
 * every route the SPA owns and never claims one it does not.
 */
export const markActiveNavEntries = (entries: TNavEntryView[], pathname: string): TNavEntryView[] =>
    entries.map(entry =>
        entry.kind === 'dropdown'
            ? {
                  ...entry,
                  items: entry.items.map(item => ({
                      ...item,
                      isActive: isSamePath(item.href, pathname),
                  })),
                  isActive: entry.items.some(item => isSamePath(item.href, pathname)),
              }
            : { ...entry, isActive: isSamePath(entry.href, pathname) },
    )
